module.exports = __webpack_public_path__ + "static/media/loff-f.9be54ce7.mp3";